<template>

</template>

<script>
    export default {
      name: "jinsihou.vue",
      mounted: function () {
        window.location.href="https://www.pingxingyun.com/console/api/poc/hostAppli/start?appliId=1060522320956751872"
      },
    }

</script>

<style scoped>

</style>



// WEBPACK FOOTER //
// src/components/jinsihou.vue